export const SHOW_POPUP = "SHOW_POPUP";
export const HIDE_POPUP = "HIDE_POPUP";
export const SET_CURRENT_IMAGE_INDEX = "SET_CURRENT_IMAGE_INDEX"

export const showPopup = payload => dispatch => {
  dispatch({ type: SHOW_POPUP, payload });
};

export const hidePopup = () => dispatch => {
  dispatch({
    type: HIDE_POPUP,
  });
};



// WEBPACK FOOTER //
// ./actions/popupActions.js